if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				this.submitting = false;

				if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");
				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitting || this.submitButton.getAttribute("aria-disabled") === "true") return;
				this.submitting = true;

				// V3.9 performance instrumentation. Marks are intentionally silent and
				// can be inspected with performance.getEntriesByType('measure').
				try {
					performance.clearMarks("delulu-atc-start");
					performance.clearMarks("delulu-atc-response-headers");
					performance.clearMarks("delulu-atc-response-body");
					performance.clearMarks("delulu-atc-render-start");
					performance.clearMarks("delulu-atc-render-end");
					performance.clearMeasures("delulu-atc-to-response-headers");
					performance.clearMeasures("delulu-atc-request-complete");
					performance.clearMeasures("delulu-atc-cart-dom");
					performance.clearMeasures("delulu-atc-to-rendered");
					performance.mark("delulu-atc-start");
				} catch (_) {}

				this.handleErrorMessage();

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				const quantityInput =
					this.form.querySelector(".qtyboxinput") ||
					this.closest("product-form")?.querySelector(".qtyboxinput");

				if (quantityInput && !formData.has("quantity")) {
					formData.append("quantity", quantityInput.value);
				}

				/*
				 * QIKIFY COMPATIBILITY FAST PATH
				 * Qikify works reliably with Kick's normal successful cart-render lifecycle.
				 * Keep that lifecycle, but the cart-drawer Liquid itself has been made lean:
				 * the expensive native recommendation/metafield engine is no longer rendered.
				 */
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => {
						try {
							performance.mark("delulu-atc-response-headers");
							performance.measure("delulu-atc-to-response-headers", "delulu-atc-start", "delulu-atc-response-headers");
						} catch (_) {}
						return response.json();
					})
					.then((response) => {
						try {
							performance.mark("delulu-atc-response-body");
							performance.measure("delulu-atc-request-complete", "delulu-atc-start", "delulu-atc-response-body");
						} catch (_) {}
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
							if (soldOutMessage) {
								this.submitButton.querySelector("span")?.classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
							}
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						this.error = false;

						// Preserve Kick/Qikify's known-good cart lifecycle, but explicitly tell
						// CartItems that the fresh drawer is already in this response so it must
						// NOT issue the old redundant second /cart request.
						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: "product-form",
							productVariantId: formData.get("id"),
							skipCartRefresh: true,
						});

						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => this.cart?.renderContents?.(response));
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							try { performance.mark("delulu-atc-render-start"); } catch (_) {}
							this.cart.renderContents(response);
						}
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						if (this.cart && this.cart.classList.contains("is-empty")) {
							this.cart.classList.remove("is-empty");
						}
						this.submitting = false;
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
				if (errorMessage) this.errorMessage.textContent = errorMessage;
			}
		}
	);
}
